import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import CourseDetails from "./CourseDetails";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ActivityHistory = () => {
  const [tabValue, setTabValue] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  return (
    <Card sx={{ mt: 4 }} className="cards">
      <Box className="custom_tabs">
        <Box className="flx_sc">
          <Tabs
            value={tabValue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Courses Searched" {...a11yProps(0)} />
            <Tab label="Courses Viewed" {...a11yProps(1)} />
            <Tab label="Courses Completed" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={tabValue} index={0}>
          <CourseDetails />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <CourseDetails />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <CourseDetails />
        </CustomTabPanel>
      </Box>
    </Card>
  );
};

export default ActivityHistory;
